
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import { TCModel } from "@iabtechlabtcf/core";
import { ampLogInfo } from "@/util";

@Component
export default class LayerOne extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";
  features : any[] = [] 
  stacks : any[] = [] 
  partnerCount:any = "";

	mounted(): void {
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

		//@ts-ignore
		let model: TCModel = window.__cmpTCModel;

  		//@ts-ignore
      if ( model && window.__GVL ) {
      //@ts-ignore
      this.features = window.__GVL.specialFeatures;
		//@ts-ignore
    this.stacks = [ window.__GVL.purposes["1"], window.__GVL.stacks["42"] ];
		//@ts-ignore
    this.partnerCount = Object.keys( window.__GVL.vendors ).length.toString();

      //@ts-ignore
    } else if ( model && model.specialFeatures ) {
		  //@ts-ignore
      this.features = model.specialFeatures;
		  //@ts-ignore
      this.stacks = [ model.purposes["1"], model.stacks["42"] ];
    }

	}

  @Emit('changeViewEvent')
  manageSettingsClick(): string {
    return 'layerTwo'
		// this.$emit("changeViewEvent", "layerTwo");
	}

  @Emit('changeViewEvent')
  vendorsClick(): string {
    return 'layerThree'
    //this.$emit("changeViewEvent", "layerThree");
	}

  @Emit('changeViewEvent')
	acceptAllClick(): string {

    debugger;
    console.log("GPP: Accept All Clicked");
//@ts-ignore
    if (window.__GVL && window.__GVL.vendors) {
//@ts-ignore
      const allVendorIds = Object.keys(window.__GVL.vendors).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
//@ts-ignore
      if (typeof this.$root.__markDisclosedVendorIds === 'function') {
//@ts-ignore
        this.$root.__markDisclosedVendorIds(allVendorIds);
      }
    }
//@ts-ignore
		this.$root.storeAcceptAllTCString();
    return 'close'
		// this.$emit("changeViewEvent", "close");
	}

  @Emit
	storeAcceptAllTCString() { }

  @Emit
	storeRejectAllTCString() { }
  
  @Emit
	storeTCString() { }

  
}
